import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { getApiBaseUrl } from "../../../shared_component/utils/urlUtils"
import NotificationSystem from "react-notification-system"
import * as Sentry from "@sentry/react"

const RequestFuelCard = ({ flutterApp, user, handleChange = () => {} }) => {
  const hostElementRef = useRef(null)
  const errorRef = useRef(null)
  const requestCardRef = useRef(null)
  const notificationSystem = useRef()

  const showError = (err) => {
    notificationSystem.current.addNotification({
      title: "Error!",
      message: err,
      level: "error",
      position: "tr",
      autoDismiss: 5
    })
    Sentry.captureException(err)
  }

  const cardRequestSuccessful = () => {
    handleChange()
  }

  useEffect(() => {
    const baseURL = getApiBaseUrl()

    window._errorScreenInit = () => {
      window._errorScreenInit = () => {}
      errorRef.current = window._errorScreen
      errorRef.current.listenShowError(showError)
    }

    window._requestFuelCardScreenInit = () => {
      // window._requestFuelCardScreenInit = () => {}
      requestCardRef.current = window._requestFuelCardScreen
      requestCardRef.current.listenCardRequestSuccessful(cardRequestSuccessful)
    }

    if (flutterApp && hostElementRef.current) {
      const userData = {
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        cellPhone: user.cellPhone,
        auth_token: user.authentication_token
      }
      const data = {
        auth_token: user.authentication_token,
        user: userData,
        baseURL: baseURL
      }
      flutterApp.addView({
        hostElement: hostElementRef.current,
        initialData: {
          widget: "request_fuel_card",
          data: JSON.stringify(data)
        }
      })
    }
  }, [flutterApp])

  return (
    <div className="request-card-container">
      <div className="request-card-box">
        <div ref={hostElementRef} />
      </div>
      <NotificationSystem ref={notificationSystem} />
    </div>
  )
}

const mapStateToProps = (state) => {
  const { flutterApp } = state.flutterInit
  const user = state.user || {}

  return {
    flutterApp: flutterApp,
    user: user
  }
}

export default connect(mapStateToProps)(RequestFuelCard)
